import React from 'react';
import styled from 'styled-components';
import { Poppins, Tooltip } from 'src/common';
import { LegendParams } from '../types';

const Div = styled.div<{ $opacity?: number; $disabled?: boolean }>`
  .item {
    display: flex;
    align-items: center;
    user-select: none;
    cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
    opacity: ${({ $opacity }) => $opacity ?? 1};
    ${({ $disabled }) => ($disabled ? 'pointer-events: none;' : '')}
  }
`;

const MarkerLine = styled.div<{ $color: string }>`
  border-radius: 2px;
  overflow: hidden;
  height: 4px;
  width: 24px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  background-color: ${({ $color }) => $color};
`;

const MarkerDash = styled.div<{ $color: string }>`
  border-radius: 2px;
  overflow: hidden;
  height: 4px;
  width: 24px;
  margin-right: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 2px;
  .gray-dot {
    background-color: ${({ $color }) => $color};
  }
`;

export const Item: React.FC<LegendParams> = ({
  title,
  id,
  tooltip = '',
  onClick,
  type = 'line',
  color,
  opacity,
  disabled,
}) => {
  return (
    <Div $opacity={disabled ? 0.23 : opacity} $disabled={disabled}>
      <Tooltip dataHtml={tooltip} dataId={id} place="top">
        <div className="item" id={id} onClick={disabled ? undefined : onClick} data-cy={id}>
          {type === 'line' && <MarkerLine $color={color} />}
          {type === 'dash' && (
            <MarkerDash $color={color}>
              <div className="gray-dot" />
              <div className="gray-dot" />
              <div className="gray-dot" />
              <div className="gray-dot" />
            </MarkerDash>
          )}

          <Poppins weight={500} color="davysGrey" px={14}>
            {title}
          </Poppins>
        </div>
      </Tooltip>
    </Div>
  );
};
